export const WELCOME_HEADER = 'Welcome!';
export const WELCOME_SUB_HEADER = 'Sign Up';
